.loading-container-flex {
    width: 100%;
    height: 100%;
    /*  position: absolute;
    top: 50%;
    left: 50%; 
    transform: translate(-50%, -50%);
    background-color: whitesmoke;*/
}

.loader {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    display: inline-block;
    border-top: 5px solid #2d95a4;
    border-right: 5px solid transparent;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
}

.loader::after {
    content: '';
    box-sizing: border-box;
    position: absolute;
    left: 0;
    top: 0;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    border-left: 5px solid #6f7271;
    border-bottom: 5px solid transparent;
    animation: rotation 0.5s linear infinite reverse;
}

.color-text-loading {
    color: #98989a;
}

@keyframes rotation {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}